
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function BenefitsSection() {
  const { ref: sectionRef, isVisible } = useScrollAnimation({ threshold: 0.1 });

  const benefits = [
    {
      icon: 'ri-time-line',
      title: 'Atendimento 24h',
      description: 'Responda clientes a qualquer hora, mesmo enquanto você dorme.',
      color: 'from-primary to-accent-cyan',
    },
    {
      icon: 'ri-repeat-line',
      title: 'Follow-up Automático',
      description: 'Nunca mais esqueça de retornar. A IA faz isso por você.',
      color: 'from-secondary to-accent-purple',
    },
    {
      icon: 'ri-send-plane-line',
      title: 'Disparos em Massa',
      description: 'Campanhas e remarketing para toda sua base de contatos.',
      color: 'from-primary to-accent-cyan',
    },
    {
      icon: 'ri-database-2-line',
      title: 'CRM Integrado',
      description: 'Histórico organizado de todas as conversas e clientes.',
      color: 'from-secondary to-accent-purple',
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: 'Dashboard Completo',
      description: 'Métricas reais de desempenho em tempo real.',
      color: 'from-primary to-accent-cyan',
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Agendamento Inteligente',
      description: 'Marque reuniões e compromissos automaticamente.',
      color: 'from-secondary to-accent-purple',
    },
    {
      icon: 'ri-team-line',
      title: 'Múltiplos Agentes',
      description: 'Agentes especializados por nicho ou departamento.',
      color: 'from-primary to-accent-cyan',
    },
    {
      icon: 'ri-mail-send-line',
      title: 'Email Marketing',
      description: 'Integração completa com campanhas de email.',
      color: 'from-secondary to-accent-purple',
    },
    {
      icon: 'ri-rocket-line',
      title: 'Escalabilidade Total',
      description: 'Do 1º ao 10.000º atendimento sem perder qualidade.',
      color: 'from-primary to-accent-cyan',
    },
  ];

  return (
    <section id="beneficios" className="py-16 sm:py-24 bg-gradient-to-b from-dark to-navy-dark">
      <div ref={sectionRef} className="max-w-7xl mx-auto px-4 sm:px-6">
        <div 
          className={`text-center mb-10 sm:mb-16 transition-all duration-700 ease-out ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6">
            Benefícios <span className="text-transparent bg-clip-text bg-gradient-to-r from-secondary to-accent-purple">Principais</span>
          </h2>
          <p className="text-sm sm:text-lg text-gray-400 max-w-2xl mx-auto px-2">
            Tudo que você precisa para transformar seu atendimento em uma máquina de vendas.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-6">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className={`group bg-dark-secondary border border-dark-border rounded-lg sm:rounded-xl p-4 sm:p-6 hover:border-secondary/50 transition-all hover:shadow-lg hover:shadow-secondary/10 duration-700 ease-out ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: `${100 + index * 80}ms` }}
            >
              <div className={`w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-gradient-to-r ${benefit.color} rounded-lg mb-3 sm:mb-4 group-hover:scale-110 transition-transform`}>
                <i className={`${benefit.icon} text-xl sm:text-2xl text-dark`}></i>
              </div>
              <h3 className="text-sm sm:text-lg font-bold mb-1 sm:mb-2 text-white">{benefit.title}</h3>
              <p className="text-gray-400 text-xs sm:text-sm leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
